import { validate } from "uuid";

export const isGuid = (value: unknown) => {
  return typeof value === "string" && validate(value);
};
